<template>
    <div class="yearSetting">
        <div class="setting-container" v-loading="loading">
            <el-form ref="ruleFormRef" style="max-width: 600px" :model="settingForm" :rules="rules" label-width="auto">
                <div class="flex">
                    <div class="card">
                        <div class="label-title">
                            馆藏年份
                        </div>
                        <div class="sub-card">
                            <el-form-item label="外文期刊" prop="ejCollectionYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ejCollectionYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="外文图书" prop="ebCollectionYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ebCollectionYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文期刊" prop="cnCollectionYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cnCollectionYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文图书" prop="cbCollectionYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cbCollectionYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="card">
                        <div class="label-title">
                            下载量年份
                        </div>
                        <div class="sub-card">
                            <el-form-item label="外文期刊" prop="ejDownloadYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ejDownloadYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="外文图书" prop="ebDownloadYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ebDownloadYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文期刊" prop="cjDownloadYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cjDownloadYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文图书" prop="cbDownloadYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cbDownloadYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <div class="flex">
                    <div class="card">
                        <div class="label-title">
                            引用量年份
                        </div>
                        <div class="sub-card">
                            <el-form-item label="外文期刊" prop="ejQuoteYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ejQuoteYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文期刊" prop="cjQuoteYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cjQuoteYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="card">
                        <div class="label-title">
                            发文量年份
                        </div>
                        <div class="sub-card">
                            <el-form-item label="外文期刊" prop="ejDispatchYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.ejDispatchYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                            <el-form-item label="中文期刊" prop="cjDispatchYear">
                                <el-date-picker value-format="YYYY" v-model="settingForm.cjDispatchYear" type="year"
                                    placeholder="请输入/选择年份" />
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>

            <div class="">
                <el-button type="primary" @click="submit">确 认</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { MessageBox } from "@/js/utils/commonJs";
import { findOneSchoolMapData, addOrUpdateSchoolMapData } from "@/js/network/main";
import { ref, reactive, computed } from "vue";
const rules = reactive({
    name: [
        { required: true, message: '请输入名称', trigger: 'blur' },
    ],
    region: [
        { required: true, message: '请选择区域', trigger: 'blur' },
    ],
})

const settingForm = reactive({
    ejCollectionYear: 0,
    ebCollectionYear: 0,
    cnCollectionYear: 0,
    cbCollectionYear: 0,
    ejDownloadYear: 0,
    ebDownloadYear: 0,
    cjDownloadYear: 0,
    cbDownloadYear: 0,
    ejQuoteYear: 0,
    cjQuoteYear: 0,
    ejDispatchYear: 0,
    cjDispatchYear: 0,
    id:"",
})

let loading = ref(false);

const submit = () => {
    if(loading.value) {
        return;
    }
    loading.value = true;
    let data = JSON.parse(JSON.stringify(settingForm));
    for (const key in data) {
        data[key] = data[key] || 0;
    }
    if(!data.id) delete data.id;
    addOrUpdateSchoolMapData(data).then(res => {
        loading.value = false;
        if (!res.success) {
            MessageBox.error(res.msg);
            return;
        }
    }).catch(err => {
        loading.value = false;
    })
}

const init = () => {
    loading.value = true;
    findOneSchoolMapData().then(res => {
        loading.value = false;
        if (!res.success) {
            MessageBox.error(res.msg);
            return;
        }
        if (res.data) {
            for (const key in settingForm) {
                settingForm[key] = (res.data[key] + '') || 0;
            }
        }
    }).catch(err => {
        loading.value = false;
    })
}

init()
</script>
<style lang="scss" scoped>
.yearSetting {
    padding: 20px 0;
}

.label-title {
    font-size: 14px;
    color: #424655;
    font-weight: 500;
    margin-bottom: 12px;
}

.sub-card {
    padding-left: 24px;
}

.card {
    min-width: 400px;
}
</style>